<script setup>
import { onMounted, computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { LoaderIcon } from 'vue-tabler-icons';
import Previewer from '@/components/Previewer.vue';
import { fetchResources } from '@/connectors/ras';
import Table from '@/components/Table.vue';

const store = useStore();
const route = useRoute();
const model = computed(() => store.getters['models/currentModel']);
const loading = ref(true);
const materials = ref([]);

onMounted(async () => {
  loading.value = true;
  try {
    await store.dispatch('models/fetchModelById', route.params.modelId);

    const {
      files: [gltfResource],
    } = model.value;

    gltfResource.name = gltfResource.name.toLowerCase();

    const gltfJSON = await fetch(gltfResource.url).then((res) => res.json());

    const {
      data: { objects: materialResources },
    } = await fetchResources(
      { names: gltfJSON.materials.map(({ name }) => name) },
      { resourceType: 'material', request: store.state.users.user.session.request },
    );

    materials.value = materialResources;
  } finally {
    loading.value = false;
  }
});
</script>

<template>
  <section class="h-full w-full">
    <div v-if="!loading && model" class="model-container">
      <h2 class="model__name col-span-3 flex flex-grow text-2xl">{{ model.name }}</h2>
      <div class="col-span-1 w-full">
        <previewer :key="model.id" :model="model" class="w-full" />
      </div>

      <Table
        :columns="[
          { name: 'name', title: 'Name' },
          { name: 'shortId', title: 'Short Id' },
          { name: 'type', title: 'Type' },
          { name: 'version', title: 'Latest Version' },
        ]"
        :rows="materials"
        title="Materials"
        class="model__materials col-span-2"
      ></Table>

      <Table
        :columns="[
          { name: 'id', title: 'ID' },
          { name: 'version', title: 'Version' },
        ]"
        :rows="[model]"
        title="Versions"
        class="model__versions col-span-2"
      ></Table>
    </div>
    <div
      v-if="loading"
      class="flex h-full w-full items-center justify-center bg-black bg-opacity-20 text-4xl text-brand-600"
    >
      <loader-icon class="animate h-12 w-12 animate-spin" style="animation-duration: 7s" />
    </div>
  </section>
</template>

<style lang="postcss" scoped>
.model-container {
  @apply relative grid h-full w-full grid-cols-4 items-start gap-6 p-6;
}
</style>
